// ReleaseNote4.jsx
import { Box, Typography } from "@mui/material";

const ReleaseNote4 = () => {
  return (
    <Box sx={{ backgroundColor: "#fff" }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        Release 4.0
      </Typography>

      <Typography variant="body2" sx={{ mb: 3 }}>
        Introducing new forms and module enhancements across JUNE.
      </Typography>

      <Box>
        <Typography variant="h5" sx={{ mb: 1 }}>
          <strong>Key Updates and Enhancements</strong>
        </Typography>

        <ul style={{ margin: 0, paddingLeft: "5%" }}>
          <li style={{ marginBottom: "16px" }}>
            <Typography variant="body2">
              <strong>
                Forms Added – Document Generation{" "}
                <span
                  style={{
                    color: "green",
                    fontSize: "0.85em",
                    verticalAlign: "super",
                  }}
                >
                  New!
                </span>
              </strong>
              <br />
              <br />
              <strong>AIA-83:</strong> Request for Withdrawal as Attorney or
              Agent and Change of Correspondence Address
              <br />
              <strong>AIA-81A:</strong> Power of Attorney (PoA) or Revocation
              of PoA with a New PoA and Change of Correspondence Address
              <br />
              <br />
              You can now generate the above forms by simply following the
              system prompts for faster preparation and submission.
            </Typography>
          </li>

          <li>
            <Typography variant="body2">
              <strong>
                Enhancement – Bibliographic Data Extraction (US Patent)
              </strong>
              <br />
              <br />
              Two new fields have been added to the U.S. Patent Bibliographic
              Data report:
              <br />
              • Entity Size (Column S)
              <br />
              • Office Action Mailing Date (Column V)
            </Typography>
          </li>
        </ul>
      </Box>
    </Box>
  );
};

export default ReleaseNote4;
